import { httpClient } from '@/services/http/httpClient'

type RequestTechnicalOpinionParams = {
  ideaId: string
  stepId: string
  specialist: string
  message: string
  deadline: Date
}

export async function requestTechnicalOpinion({
  ideaId,
  stepId,
  specialist,
  message,
  deadline,
}: RequestTechnicalOpinionParams): Promise<void> {
  await httpClient.post(`/ideas/evaluations/technical-review/${ideaId}`, {
    userId: specialist,
    kanbanStepId: stepId,
    message,
    deadline: deadline.toISOString(),
  })
}
